// @ts-nocheck
import { ReactElement, useEffect, useState } from 'react';

import { getMySavedPrescriptions } from '@services/myAppointmentServices';
import { IMySavedPrescriptionsListPayload } from '@interfaces/myAppointmentInterfaces';

import { useDispatch, useSelector } from 'react-redux';

import { RootState } from 'src/store/reducers';

import { NavLink } from 'react-router-dom';

import ArrowUp from '@images/svg-icons/arrowUp.svg';
import ArrowDown from '@images/svg-icons/arrowDown.svg';

/* SVG FOR MENU */
import MyHub from '@images/svg-icons/my-hub.svg';
import MySettings from '@images/svg-icons/my-settings.svg';
import MyInbox from '@images/svg-icons/my-inbox.svg';
import MyOrders from '@images/svg-icons/my-orders.svg';
import MyPayment from '@images/svg-icons/my-payment.svg';
import MyAddresses from '@images/svg-icons/my-addresses.svg';
import MyVision from '@images/svg-icons/my-vision.svg';
import MyEyeExam from '@images/svg-icons/my-eye-exam.svg';
import MyPrescription from '@images/svg-icons/my-prescription.svg';
import MySavedItems from '@images/svg-icons/my-saved-items.svg';
import MyStores from '@images/svg-icons/my-stores.svg';

import { getDashboardInformations } from '@services/dashboardServices';

import ButtonMenu from '@components/styled-UI/ButtonMenu';

import { getLabelFallback } from '@utils/utils';
import * as actions from '@redux-actions/';
import _ from 'lodash';

const Menu = (): ReactElement => {
    const config = useSelector((state: RootState) => state.common.config);
    const isMobile = useSelector((state: RootState) => state.common.isMobile);
    const dashboardInformations = useSelector(
        (state: RootState) => state.dashboard.dashboardInformations
    );

    // ANALYTICS FOR ORDERS
    const myOrdersRetailInformation = useSelector((state: RootState) => state.myPurchases.retailOrders)
    const myOrdersOnlineInformation = useSelector((state: RootState) => state.myPurchases.onlineOrders)

    // ANALYTICS FOR MY PRESCRIPTION
    const mySavedPrescriptions = useSelector((state: RootState) => state.myAppointment.mySavedPrescriptions);
    const [userHasPrescription, setUserHasPrescription] = useState('');

    useEffect(() => {
        const mySavedPrescriptionsPayload: IMySavedPrescriptionsListPayload = {
            isMockRequest: config.mockRequest,
            storeId: config.storeId,
        };

        dispatch(getMySavedPrescriptions(mySavedPrescriptionsPayload));

        return () => {
            actions.getMySavedPrescriptionsSuccess(null);
        };
    }, []);

    useEffect(() => {
        if (!!mySavedPrescriptions && mySavedPrescriptions?.length > 0) {
            setUserHasPrescription('1');
        }
    }, [mySavedPrescriptions])

    const switchForDevice = (value) => {
        switch (value) {
            case 'desktop':
                return 'D';
            case 'mobile':
                return 'M';
            case 'tablet':
                return 'T';
            case 'responsive':
                return 'X';
            case 'ipad':
                return 'iPAD';
            default:
                return value;
        }
    }

    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(getDashboardInformations(config.mockRequest, config.storeId));
        const menuSections = document.querySelectorAll('.menu-section-title');
        const openedSection = document.querySelector('.show-section');
        if (isMobile === true) {
            menuSections.forEach(q =>
                q.addEventListener('click', () => {
                    if (!q.nextElementSibling.classList.contains('show-section')) {
                        if (!!openedSection) {
                            openedSection.classList.remove('show-section');
                            q.lastElementChild.classList.remove('show-section');
                        }
                        q.nextElementSibling.classList.add('show-section');
                        q.lastElementChild.classList.add('show-section');
                    } else {
                        q.nextElementSibling.classList.remove('show-section');
                        q.lastElementChild.classList.remove('show-section');
                    }
                })
            );
        }
    }, [isMobile]);

    const getArrowIcons = () => {
        return (
            <div className="menu-section-title-arrows">
                <span className="arrow-up">
                    <ArrowUp />
                </span>
                <span className="arrow-down">
                    <ArrowDown />
                </span>
            </div>
        );
    };

    return (
        <nav
            id="sidebarMenuId"
            aria-label="sidebar Menu"
            className={`menu${isMobile ? '-mobile' : ''}`}
        >
            <h2 className="menu-title">{getLabelFallback('MENU_TITLE')}</h2>
            <div className="menu-section">
                <ul className="menu-section-list">
                    <li className="menu-section-list-link">
                        <NavLink
                            onClick={() => {
                                tealium_data2track.push({
                                    id: 'Click',
                                    data_element_id: 'MyAccount_MyHub',
                                });
                                // window.universalTagData.Page_Type= 'UserSummary';
                                let obj = {
                                    id: 'VirtualPage-View',
                                    Page_Type: 'Static',
                                    Page_Section1: 'Account',
                                    Page_Section2: '',
                                    Page_Brand: window.universalTagData.Page_Brand !== undefined ? window.universalTagData.Page_Brand : '',
                                    Page_Country: window.universalTagData.Page_Country !== undefined ? window.universalTagData.Page_Country : '',
                                    Page_Platform: window.universalTagData.Page_Platform !== undefined ? window.universalTagData.Page_Platform : '',
                                    Page_Language: window.universalTagData.Page_Language !== undefined ? window.universalTagData.Page_Language : '',
                                    Page_DeviceType: window.universalTagData.Page_DeviceType !== undefined ? switchForDevice(window.universalTagData.Page_DeviceType) : '',
                                    Page_Server: window.universalTagData.Page_Server,
                                    User_LoginStatus: window.universalTagData.User_LoginStatus !== undefined ? window.universalTagData.User_LoginStatus : '',
                                    User_LoginType: window.universalTagData.User_LoginType !== undefined ? window.universalTagData.User_LoginType : '',
                                    User_Email_MD5: window.universalTagData.User_Email_MD5 !== undefined ? window.universalTagData.User_Email_MD5 : '',
                                    User_Email_SHA256: window.universalTagData.User_Email_SHA256 !== undefined ? window.universalTagData.User_Email_SHA256 : '',
                                    User_Phone_MD5: window.universalTagData.User_Phone_MD5 !== undefined ? window.universalTagData.User_Phone_MD5 : '',
                                    User_Phone_SHA256: window.universalTagData.User_Phone_SHA256 !== undefined ? window.universalTagData.User_Phone_SHA256 : '',
                                    User_EmailOptin: window.universalTagData.User_EmailOptin !== undefined ? window.universalTagData.User_EmailOptin : '0',
                                    User_Id: window.universalTagData.User_Id.toString(),
                                    User_Segments: window.universalTagData.User_Segments !== undefined ? window.universalTagData.User_Segments : '',
                                    Fs_IsConnected: window.universalTagData.Fs_IsConnected !== undefined ? window.universalTagData.Fs_IsConnected : '',
                                    Page_UserFace: window.universalTagData.Page_UserFace !== undefined ? window.universalTagData.Page_UserFace : '',
                                    Page_UserStyle: window.universalTagData.Page_UserStyle !== undefined ? window.universalTagData.Page_UserStyle : '',
                                    //...window.universalTagData //not work with all universalTagData (not push event but modify existing event)
                                };
                                if (window.universalTagData.User_Country !== undefined && window.universalTagData.User_Country !== 'N.A.' && window.universalTagData.User_Country !== 'UNDEFINED') {
                                    obj.User_Country = window.universalTagData.User_Country;
                                }
                                window?.tealium_data2track?.push(obj);
                                dispatch(actions.setIsMenuMobileSelected(true));
                            }}
                            className={({ isActive }) => (isActive ? 'active' : undefined)}
                            to={config.pagesUrl.dashboard}
                        >
                            <ButtonMenu label={getLabelFallback('DASHBOARD_MENU_LABEL')}>
                                <MyHub />
                            </ButtonMenu>
                        </NavLink>
                    </li>
                    <li className="menu-section-list-link">
                        <NavLink
                            onClick={() => {
                                tealium_data2track.push({
                                    id: 'Click',
                                    data_element_id: 'MyAccount_MySettings',
                                });
                                // window.universalTagData.Page_Type= 'Profile';
                                let obj = {
                                    id: 'VirtualPage-View',
                                    Page_Type: 'Static',
                                    Page_Section1: 'Account',
                                    Page_Section2: '',
                                    Page_Brand: window.universalTagData.Page_Brand !== undefined ? window.universalTagData.Page_Brand : '',
                                    Page_Country: window.universalTagData.Page_Country !== undefined ? window.universalTagData.Page_Country : '',
                                    Page_Platform: window.universalTagData.Page_Platform !== undefined ? window.universalTagData.Page_Platform : '',
                                    Page_Language: window.universalTagData.Page_Language !== undefined ? window.universalTagData.Page_Language : '',
                                    Page_DeviceType: window.universalTagData.Page_DeviceType !== undefined ? switchForDevice(window.universalTagData.Page_DeviceType) : '',
                                    Page_Server: window.universalTagData.Page_Server,
                                    User_LoginStatus: window.universalTagData.User_LoginStatus !== undefined ? window.universalTagData.User_LoginStatus : '',
                                    User_LoginType: window.universalTagData.User_LoginType !== undefined ? window.universalTagData.User_LoginType : '',
                                    User_Email_MD5: window.universalTagData.User_Email_MD5 !== undefined ? window.universalTagData.User_Email_MD5 : '',
                                    User_Email_SHA256: window.universalTagData.User_Email_SHA256 !== undefined ? window.universalTagData.User_Email_SHA256 : '',
                                    User_Phone_MD5: window.universalTagData.User_Phone_MD5 !== undefined ? window.universalTagData.User_Phone_MD5 : '',
                                    User_Phone_SHA256: window.universalTagData.User_Phone_SHA256 !== undefined ? window.universalTagData.User_Phone_SHA256 : '',
                                    User_EmailOptin: window.universalTagData.User_EmailOptin !== undefined ? window.universalTagData.User_EmailOptin : '0',
                                    User_Id: window.universalTagData.User_Id.toString(),
                                    User_Segments: window.universalTagData.User_Segments !== undefined ? window.universalTagData.User_Segments : '',
                                    Fs_IsConnected: window.universalTagData.Fs_IsConnected !== undefined ? window.universalTagData.Fs_IsConnected : '',
                                    Page_UserFace: window.universalTagData.Page_UserFace !== undefined ? window.universalTagData.Page_UserFace : '',
                                    Page_UserStyle: window.universalTagData.Page_UserStyle !== undefined ? window.universalTagData.Page_UserStyle : '',
                                    //...window.universalTagData //not work with all universalTagData (not push event but modify existing event)
                                };
                                if (window.universalTagData.User_Country !== undefined && window.universalTagData.User_Country !== 'N.A.' && window.universalTagData.User_Country !== 'UNDEFINED') {
                                    obj.User_Country = window.universalTagData.User_Country;
                                }
                                window?.tealium_data2track?.push(obj);
                                dispatch(actions.setIsMenuMobileSelected(true));
                            }}
                            className={({ isActive }) => (isActive ? 'active' : undefined)}
                            to={config.pagesUrl.myProfile.settings}
                        >
                            <ButtonMenu
                                label={getLabelFallback('DASHBOARD_SETTINGS_MENU_LABEL')}
                                subtitle={getLabelFallback(
                                    'DASHBOARD_SETTINGS_MENU_SUBTITLE_LABEL'
                                )}
                            >
                                <MySettings />
                            </ButtonMenu>
                        </NavLink>
                    </li>
                    <li className="menu-section-list-link">
                        <NavLink
                            onClick={() => {
                                tealium_data2track.push({
                                    id: 'Click',
                                    data_element_id: 'MyAccount_MyInbox',
                                });
                                // window.universalTagData.Page_Type= 'Subscriptions';
                                let obj = {
                                    id: 'VirtualPage-View',
                                    Page_Type: 'Static',
                                    Page_Section1: 'Account',
                                    Page_Section2: '',
                                    Page_Brand: window.universalTagData.Page_Brand !== undefined ? window.universalTagData.Page_Brand : '',
                                    Page_Country: window.universalTagData.Page_Country !== undefined ? window.universalTagData.Page_Country : '',
                                    Page_Platform: window.universalTagData.Page_Platform !== undefined ? window.universalTagData.Page_Platform : '',
                                    Page_Language: window.universalTagData.Page_Language !== undefined ? window.universalTagData.Page_Language : '',
                                    Page_DeviceType: window.universalTagData.Page_DeviceType !== undefined ? switchForDevice(window.universalTagData.Page_DeviceType) : '',
                                    Page_Server: window.universalTagData.Page_Server,
                                    User_LoginStatus: window.universalTagData.User_LoginStatus !== undefined ? window.universalTagData.User_LoginStatus : '',
                                    User_LoginType: window.universalTagData.User_LoginType !== undefined ? window.universalTagData.User_LoginType : '',
                                    User_Email_MD5: window.universalTagData.User_Email_MD5 !== undefined ? window.universalTagData.User_Email_MD5 : '',
                                    User_Email_SHA256: window.universalTagData.User_Email_SHA256 !== undefined ? window.universalTagData.User_Email_SHA256 : '',
                                    User_Phone_MD5: window.universalTagData.User_Phone_MD5 !== undefined ? window.universalTagData.User_Phone_MD5 : '',
                                    User_Phone_SHA256: window.universalTagData.User_Phone_SHA256 !== undefined ? window.universalTagData.User_Phone_SHA256 : '',
                                    User_EmailOptin: window.universalTagData.User_EmailOptin !== undefined ? window.universalTagData.User_EmailOptin : '0',
                                    User_Id: window.universalTagData.User_Id.toString(),
                                    User_Segments: window.universalTagData.User_Segments !== undefined ? window.universalTagData.User_Segments : '',
                                    Fs_IsConnected: window.universalTagData.Fs_IsConnected !== undefined ? window.universalTagData.Fs_IsConnected : '',
                                    Page_UserFace: window.universalTagData.Page_UserFace !== undefined ? window.universalTagData.Page_UserFace : '',
                                    Page_UserStyle: window.universalTagData.Page_UserStyle !== undefined ? window.universalTagData.Page_UserStyle : '',
                                    //...window.universalTagData //not work with all universalTagData (not push event but modify existing event)
                                };
                                if (window.universalTagData.User_Country !== undefined && window.universalTagData.User_Country !== 'N.A.' && window.universalTagData.User_Country !== 'UNDEFINED') {
                                    obj.User_Country = window.universalTagData.User_Country;
                                }
                                window?.tealium_data2track?.push(obj);
                                dispatch(actions.setIsMenuMobileSelected(true));
                            }}
                            className={({ isActive }) => (isActive ? 'active' : undefined)}
                            to={config.pagesUrl.myProfile.inbox}
                        >
                            <ButtonMenu label={getLabelFallback('DASHBOARD_INBOX_MENU_LABEL')}>
                                <MyInbox />
                            </ButtonMenu>
                        </NavLink>
                    </li>
                </ul>
                <div className="menu-section-bottombar"></div>
            </div>
            <div className="menu-section">
                <h3 className="menu-section-title">
                    {getLabelFallback('PURCHASES_SECTION_MENU_TITLE')}{' '}
                    {isMobile === true ? getArrowIcons() : null}
                </h3>
                <ul className="menu-section-list">
                    <li className="menu-section-list-link">
                        <NavLink
                            onClick={() => {
                                tealium_data2track.push({
                                    id: 'Click',
                                    data_element_id: 'MyAccount_MyOrders',
                                });
                                dispatch(actions.setIsMenuMobileSelected(true));
                            }}
                            className={({ isActive }) => (isActive ? 'active' : undefined)}
                            to={config.pagesUrl.myPurchases.onlineOrders}
                        >
                            <ButtonMenu
                                label={getLabelFallback('PURCHASES_ONLINE_ORDERS_MENU_LABEL')}
                            >
                                <MyOrders />
                            </ButtonMenu>
                        </NavLink>
                    </li>
                    <li className="menu-section-list-link">
                        <NavLink
                            onClick={() => {
                                tealium_data2track.push({
                                    id: 'Click',
                                    data_element_id: 'MyAccount_MyPaymentMethods',
                                });
                                // window.universalTagData.Page_Type= 'Profile';
                                let obj = {
                                    id: 'VirtualPage-View',
                                    Page_Type: 'Static',
                                    Page_Section1: 'Account',
                                    Page_Section2: '',
                                    Page_Brand: window.universalTagData.Page_Brand !== undefined ? window.universalTagData.Page_Brand : '',
                                    Page_Country: window.universalTagData.Page_Country !== undefined ? window.universalTagData.Page_Country : '',
                                    Page_Platform: window.universalTagData.Page_Platform !== undefined ? window.universalTagData.Page_Platform : '',
                                    Page_Language: window.universalTagData.Page_Language !== undefined ? window.universalTagData.Page_Language : '',
                                    Page_DeviceType: window.universalTagData.Page_DeviceType !== undefined ? switchForDevice(window.universalTagData.Page_DeviceType) : '',
                                    Page_Server: window.universalTagData.Page_Server,
                                    User_LoginStatus: window.universalTagData.User_LoginStatus !== undefined ? window.universalTagData.User_LoginStatus : '',
                                    User_LoginType: window.universalTagData.User_LoginType !== undefined ? window.universalTagData.User_LoginType : '',
                                    User_Email_MD5: window.universalTagData.User_Email_MD5 !== undefined ? window.universalTagData.User_Email_MD5 : '',
                                    User_Email_SHA256: window.universalTagData.User_Email_SHA256 !== undefined ? window.universalTagData.User_Email_SHA256 : '',
                                    User_Phone_MD5: window.universalTagData.User_Phone_MD5 !== undefined ? window.universalTagData.User_Phone_MD5 : '',
                                    User_Phone_SHA256: window.universalTagData.User_Phone_SHA256 !== undefined ? window.universalTagData.User_Phone_SHA256 : '',
                                    User_EmailOptin: window.universalTagData.User_EmailOptin !== undefined ? window.universalTagData.User_EmailOptin : '0',
                                    User_Id: window.universalTagData.User_Id.toString(),
                                    User_Segments: window.universalTagData.User_Segments !== undefined ? window.universalTagData.User_Segments : '',
                                    Fs_IsConnected: window.universalTagData.Fs_IsConnected !== undefined ? window.universalTagData.Fs_IsConnected : '',
                                    Page_UserFace: window.universalTagData.Page_UserFace !== undefined ? window.universalTagData.Page_UserFace : '',
                                    Page_UserStyle: window.universalTagData.Page_UserStyle !== undefined ? window.universalTagData.Page_UserStyle : '',
                                    //...window.universalTagData //not work with all universalTagData (not push event but modify existing event)
                                };
                                if (window.universalTagData.User_Country !== undefined && window.universalTagData.User_Country !== 'N.A.' && window.universalTagData.User_Country !== 'UNDEFINED') {
                                    obj.User_Country = window.universalTagData.User_Country;
                                }
                                window?.tealium_data2track?.push(obj);
                                dispatch(actions.setIsMenuMobileSelected(true));
                            }}
                            className={({ isActive }) => (isActive ? 'active' : undefined)}
                            to={config.pagesUrl.myPurchases.paymentMethods}
                        >
                            <ButtonMenu
                                label={getLabelFallback('PURCHASES_PAYMENT_METHODS_MENU_LABEL')}
                            >
                                <MyPayment />
                            </ButtonMenu>
                        </NavLink>
                    </li>
                    <li className="menu-section-list-link">
                        <NavLink
                            onClick={() => {
                                tealium_data2track.push({
                                    id: 'Click',
                                    data_element_id: 'MyAccount_MyAddresses',
                                });
                                // window.universalTagData.Page_Type= 'Profile';
                                let obj = {
                                    id: 'VirtualPage-View',
                                    Page_Type: 'Static',
                                    Page_Section1: 'Account',
                                    Page_Section2: '',
                                    Page_Brand: window.universalTagData.Page_Brand !== undefined ? window.universalTagData.Page_Brand : '',
                                    Page_Country: window.universalTagData.Page_Country !== undefined ? window.universalTagData.Page_Country : '',
                                    Page_Platform: window.universalTagData.Page_Platform !== undefined ? window.universalTagData.Page_Platform : '',
                                    Page_Language: window.universalTagData.Page_Language !== undefined ? window.universalTagData.Page_Language : '',
                                    Page_DeviceType: window.universalTagData.Page_DeviceType !== undefined ? switchForDevice(window.universalTagData.Page_DeviceType) : '',
                                    Page_Server: window.universalTagData.Page_Server,
                                    User_LoginStatus: window.universalTagData.User_LoginStatus !== undefined ? window.universalTagData.User_LoginStatus : '',
                                    User_LoginType: window.universalTagData.User_LoginType !== undefined ? window.universalTagData.User_LoginType : '',
                                    User_Email_MD5: window.universalTagData.User_Email_MD5 !== undefined ? window.universalTagData.User_Email_MD5 : '',
                                    User_Email_SHA256: window.universalTagData.User_Email_SHA256 !== undefined ? window.universalTagData.User_Email_SHA256 : '',
                                    User_Phone_MD5: window.universalTagData.User_Phone_MD5 !== undefined ? window.universalTagData.User_Phone_MD5 : '',
                                    User_Phone_SHA256: window.universalTagData.User_Phone_SHA256 !== undefined ? window.universalTagData.User_Phone_SHA256 : '',
                                    User_EmailOptin: window.universalTagData.User_EmailOptin !== undefined ? window.universalTagData.User_EmailOptin : '0',
                                    User_Id: window.universalTagData.User_Id.toString(),
                                    User_Segments: window.universalTagData.User_Segments !== undefined ? window.universalTagData.User_Segments : '',
                                    Fs_IsConnected: window.universalTagData.Fs_IsConnected !== undefined ? window.universalTagData.Fs_IsConnected : '',
                                    Page_UserFace: window.universalTagData.Page_UserFace !== undefined ? window.universalTagData.Page_UserFace : '',
                                    Page_UserStyle: window.universalTagData.Page_UserStyle !== undefined ? window.universalTagData.Page_UserStyle : '',
                                    //...window.universalTagData //not work with all universalTagData (not push event but modify existing event)
                                };
                                if (window.universalTagData.User_Country !== undefined && window.universalTagData.User_Country !== 'N.A.' && window.universalTagData.User_Country !== 'UNDEFINED') {
                                    obj.User_Country = window.universalTagData.User_Country;
                                }
                                window?.tealium_data2track?.push(obj);
                                dispatch(actions.setIsMenuMobileSelected(true));
                            }}
                            className={({ isActive }) => (isActive ? 'active' : undefined)}
                            to={config.pagesUrl.myPurchases.addresses}
                        >
                            <ButtonMenu
                                label={getLabelFallback('PURCHASES_MY_ADDRESSES_MENU_LABEL')}
                            >
                                <MyAddresses />
                            </ButtonMenu>
                        </NavLink>
                    </li>
                </ul>
                <div className="menu-section-bottombar"></div>
            </div>
            <div className="menu-section">
                <h3 className="menu-section-title">
                    {getLabelFallback('EYE_VISION_SECTION_MENU_TITLE')}
                    {isMobile === true ? getArrowIcons() : null}
                </h3>
                <ul className="menu-section-list">
                    <li className="menu-section-list-link">
                        <NavLink
                            onClick={() => {
                                tealium_data2track.push({
                                    id: 'Click',
                                    data_element_id: 'MyAccount_MyEyeExams',
                                });
                                // window.universalTagData.Page_Type= 'Profile';
                                let obj = {
                                    id: 'VirtualPage-View',
                                    Page_Type: 'Static',
                                    Page_Section1: 'Account',
                                    Page_Section2: '',
                                    Page_Brand: window.universalTagData.Page_Brand !== undefined ? window.universalTagData.Page_Brand : '',
                                    Page_Country: window.universalTagData.Page_Country !== undefined ? window.universalTagData.Page_Country : '',
                                    Page_Platform: window.universalTagData.Page_Platform !== undefined ? window.universalTagData.Page_Platform : '',
                                    Page_Language: window.universalTagData.Page_Language !== undefined ? window.universalTagData.Page_Language : '',
                                    Page_DeviceType: window.universalTagData.Page_DeviceType !== undefined ? switchForDevice(window.universalTagData.Page_DeviceType) : '',
                                    Page_Server: window.universalTagData.Page_Server,
                                    User_LoginStatus: window.universalTagData.User_LoginStatus !== undefined ? window.universalTagData.User_LoginStatus : '',
                                    User_LoginType: window.universalTagData.User_LoginType !== undefined ? window.universalTagData.User_LoginType : '',
                                    User_Email_MD5: window.universalTagData.User_Email_MD5 !== undefined ? window.universalTagData.User_Email_MD5 : '',
                                    User_Email_SHA256: window.universalTagData.User_Email_SHA256 !== undefined ? window.universalTagData.User_Email_SHA256 : '',
                                    User_Phone_MD5: window.universalTagData.User_Phone_MD5 !== undefined ? window.universalTagData.User_Phone_MD5 : '',
                                    User_Phone_SHA256: window.universalTagData.User_Phone_SHA256 !== undefined ? window.universalTagData.User_Phone_SHA256 : '',
                                    User_EmailOptin: window.universalTagData.User_EmailOptin !== undefined ? window.universalTagData.User_EmailOptin : '0',
                                    User_Id: window.universalTagData.User_Id.toString(),
                                    User_Segments: window.universalTagData.User_Segments !== undefined ? window.universalTagData.User_Segments : '',
                                    Fs_IsConnected: window.universalTagData.Fs_IsConnected !== undefined ? window.universalTagData.Fs_IsConnected : '',
                                    Page_UserFace: window.universalTagData.Page_UserFace !== undefined ? window.universalTagData.Page_UserFace : '',
                                    Page_UserStyle: window.universalTagData.Page_UserStyle !== undefined ? window.universalTagData.Page_UserStyle : '',
                                    //...window.universalTagData //not work with all universalTagData (not push event but modify existing event)
                                };
                                if (window.universalTagData.User_Country !== undefined && window.universalTagData.User_Country !== 'N.A.' && window.universalTagData.User_Country !== 'UNDEFINED') {
                                    obj.User_Country = window.universalTagData.User_Country;
                                }
                                window?.tealium_data2track?.push(obj);
                                dispatch(actions.setIsMenuMobileSelected(true));
                            }}
                            className={({ isActive }) => (isActive ? 'active' : undefined)}
                            to={config.pagesUrl.myAppointments.eyeExams}
                        >
                            <ButtonMenu label={getLabelFallback('EYE_EXAMS_MENU_LABEL')}>
                                <MyEyeExam />
                            </ButtonMenu>
                        </NavLink>
                    </li>
                    <li className="menu-section-list-link">
                        <NavLink
                            onClick={() => {
                                tealium_data2track.push({
                                    id: 'Click',
                                    data_element_id: 'MyAccount_MyPrescription',
                                });
                                // window.universalTagData.Page_Type= 'Profile';
                                let obj = {
                                    id: 'VirtualPage-View',
                                    Page_Type: 'Static',
                                    Page_Section1: 'Account',
                                    Page_Section2: 'MyPrescriptions',
                                    Page_Brand: window.universalTagData.Page_Brand !== undefined ? window.universalTagData.Page_Brand : '',
                                    Page_Country: window.universalTagData.Page_Country !== undefined ? window.universalTagData.Page_Country : '',
                                    Page_Platform: window.universalTagData.Page_Platform !== undefined ? window.universalTagData.Page_Platform : '',
                                    Page_Language: window.universalTagData.Page_Language !== undefined ? window.universalTagData.Page_Language : '',
                                    Page_DeviceType: window.universalTagData.Page_DeviceType !== undefined ? switchForDevice(window.universalTagData.Page_DeviceType) : '',
                                    Page_Server: window.universalTagData.Page_Server,
                                    User_LoginStatus: window.universalTagData.User_LoginStatus !== undefined ? window.universalTagData.User_LoginStatus : '',
                                    User_LoginType: window.universalTagData.User_LoginType !== undefined ? window.universalTagData.User_LoginType : '',
                                    User_Email_MD5: window.universalTagData.User_Email_MD5 !== undefined ? window.universalTagData.User_Email_MD5 : '',
                                    User_Email_SHA256: window.universalTagData.User_Email_SHA256 !== undefined ? window.universalTagData.User_Email_SHA256 : '',
                                    User_Phone_MD5: window.universalTagData.User_Phone_MD5 !== undefined ? window.universalTagData.User_Phone_MD5 : '',
                                    User_Phone_SHA256: window.universalTagData.User_Phone_SHA256 !== undefined ? window.universalTagData.User_Phone_SHA256 : '',
                                    User_EmailOptin: window.universalTagData.User_EmailOptin !== undefined ? window.universalTagData.User_EmailOptin : '0',
                                    User_Id: window.universalTagData.User_Id.toString(),
                                    User_Segments: window.universalTagData.User_Segments !== undefined ? window.universalTagData.User_Segments : '',
                                    Fs_IsConnected: window.universalTagData.Fs_IsConnected !== undefined ? window.universalTagData.Fs_IsConnected : '',
                                    Page_UserFace: window.universalTagData.Page_UserFace !== undefined ? window.universalTagData.Page_UserFace : '',
                                    Page_UserStyle: window.universalTagData.Page_UserStyle !== undefined ? window.universalTagData.Page_UserStyle : '',
                                    User_HasPrescription: userHasPrescription !== undefined && !!userHasPrescription ? userHasPrescription : '',
                                    //...window.universalTagData //not work with all universalTagData (not push event but modify existing event)
                                };
                                if (window.universalTagData.User_Country !== undefined && window.universalTagData.User_Country !== 'N.A.' && window.universalTagData.User_Country !== 'UNDEFINED') {
                                    obj.User_Country = window.universalTagData.User_Country;
                                }
                                window?.tealium_data2track?.push(obj);
                                dispatch(actions.setIsMenuMobileSelected(true));
                            }}
                            className={({ isActive }) => (isActive ? 'active' : undefined)}
                            to={config.pagesUrl.myAppointments.myPrescriptions}
                        >
                            <ButtonMenu label={getLabelFallback('MY_PRESCRIPTIONS_MENU_LABEL')}>
                                <MyPrescription />
                            </ButtonMenu>
                        </NavLink>
                    </li>
                </ul>
                <div className="menu-section-bottombar"></div>
            </div>
            <div className="menu-section">
                <h3 className="menu-section-title">
                    {getLabelFallback('FAVORITES_SECTION_MENU_TITLE')}{' '}
                    {isMobile === true ? getArrowIcons() : null}
                </h3>
                <ul className="menu-section-list">
                    <li className="menu-section-list-link">
                        <a
                            onClick={() => {
                                tealium_data2track.push({
                                    id: 'Click',
                                    data_element_id: 'MyAccount_MySavedItems',
                                });
                                // window.universalTagData.Page_Type= 'Whislist';
                                let obj = {
                                    id: 'VirtualPage-View',
                                    Page_Type: 'Whislist',
                                    Page_Section1: 'Account',
                                    Page_Section2: '',
                                    Page_Brand: window.universalTagData.Page_Brand !== undefined ? window.universalTagData.Page_Brand : '',
                                    Page_Country: window.universalTagData.Page_Country !== undefined ? window.universalTagData.Page_Country : '',
                                    Page_Platform: window.universalTagData.Page_Platform !== undefined ? window.universalTagData.Page_Platform : '',
                                    Page_Language: window.universalTagData.Page_Language !== undefined ? window.universalTagData.Page_Language : '',
                                    Page_DeviceType: window.universalTagData.Page_DeviceType !== undefined ? switchForDevice(window.universalTagData.Page_DeviceType) : '',
                                    Page_Server: window.universalTagData.Page_Server,
                                    User_LoginStatus: window.universalTagData.User_LoginStatus !== undefined ? window.universalTagData.User_LoginStatus : '',
                                    User_LoginType: window.universalTagData.User_LoginType !== undefined ? window.universalTagData.User_LoginType : '',
                                    User_Email_MD5: window.universalTagData.User_Email_MD5 !== undefined ? window.universalTagData.User_Email_MD5 : '',
                                    User_Email_SHA256: window.universalTagData.User_Email_SHA256 !== undefined ? window.universalTagData.User_Email_SHA256 : '',
                                    User_Phone_MD5: window.universalTagData.User_Phone_MD5 !== undefined ? window.universalTagData.User_Phone_MD5 : '',
                                    User_Phone_SHA256: window.universalTagData.User_Phone_SHA256 !== undefined ? window.universalTagData.User_Phone_SHA256 : '',
                                    User_EmailOptin: window.universalTagData.User_EmailOptin !== undefined ? window.universalTagData.User_EmailOptin : '0',
                                    User_Id: window.universalTagData.User_Id.toString(),
                                    User_Segments: window.universalTagData.User_Segments !== undefined ? window.universalTagData.User_Segments : '',
                                    Fs_IsConnected: window.universalTagData.Fs_IsConnected !== undefined ? window.universalTagData.Fs_IsConnected : '',
                                    Page_UserFace: window.universalTagData.Page_UserFace !== undefined ? window.universalTagData.Page_UserFace : '',
                                    Page_UserStyle: window.universalTagData.Page_UserStyle !== undefined ? window.universalTagData.Page_UserStyle : '',
                                    //...window.universalTagData //not work with all universalTagData (not push event but modify existing event)
                                };
                                if (window.universalTagData.User_Country !== undefined && window.universalTagData.User_Country !== 'N.A.' && window.universalTagData.User_Country !== 'UNDEFINED') {
                                    obj.User_Country = window.universalTagData.User_Country;
                                }
                                window?.tealium_data2track?.push(obj);
                                window.open(config.pagesUrl.myProfile.mySavedItems, '_parent')
                            }}
                            className="saved-item-button"
                        >
                            <ButtonMenu
                                label={getLabelFallback('FAVORITES_SAVED_ITEMS_MENU_LABEL')}
                            >
                                <MySavedItems />
                            </ButtonMenu>
                        </a>
                    </li>
                    <li className="menu-section-list-link">
                        <NavLink
                            onClick={() => {
                                tealium_data2track.push({
                                    id: 'Click',
                                    data_element_id: 'MyAccount_MyStores',
                                });
                                // window.universalTagData.Page_Type= 'Profile';
                                let obj = {
                                    id: 'VirtualPage-View',
                                    Page_Type: 'Static',
                                    Page_Section1: 'Account',
                                    Page_Section2: '',
                                    Page_Brand: window.universalTagData.Page_Brand !== undefined ? window.universalTagData.Page_Brand : '',
                                    Page_Country: window.universalTagData.Page_Country !== undefined ? window.universalTagData.Page_Country : '',
                                    Page_Platform: window.universalTagData.Page_Platform !== undefined ? window.universalTagData.Page_Platform : '',
                                    Page_Language: window.universalTagData.Page_Language !== undefined ? window.universalTagData.Page_Language : '',
                                    Page_DeviceType: window.universalTagData.Page_DeviceType !== undefined ? switchForDevice(window.universalTagData.Page_DeviceType) : '',
                                    Page_Server: window.universalTagData.Page_Server,
                                    User_LoginStatus: window.universalTagData.User_LoginStatus !== undefined ? window.universalTagData.User_LoginStatus : '',
                                    User_LoginType: window.universalTagData.User_LoginType !== undefined ? window.universalTagData.User_LoginType : '',
                                    User_Email_MD5: window.universalTagData.User_Email_MD5 !== undefined ? window.universalTagData.User_Email_MD5 : '',
                                    User_Email_SHA256: window.universalTagData.User_Email_SHA256 !== undefined ? window.universalTagData.User_Email_SHA256 : '',
                                    User_Phone_MD5: window.universalTagData.User_Phone_MD5 !== undefined ? window.universalTagData.User_Phone_MD5 : '',
                                    User_Phone_SHA256: window.universalTagData.User_Phone_SHA256 !== undefined ? window.universalTagData.User_Phone_SHA256 : '',
                                    User_EmailOptin: window.universalTagData.User_EmailOptin !== undefined ? window.universalTagData.User_EmailOptin : '0',
                                    User_Id: window.universalTagData.User_Id.toString(),
                                    User_Segments: window.universalTagData.User_Segments !== undefined ? window.universalTagData.User_Segments : '',
                                    Fs_IsConnected: window.universalTagData.Fs_IsConnected !== undefined ? window.universalTagData.Fs_IsConnected : '',
                                    Page_UserFace: window.universalTagData.Page_UserFace !== undefined ? window.universalTagData.Page_UserFace : '',
                                    Page_UserStyle: window.universalTagData.Page_UserStyle !== undefined ? window.universalTagData.Page_UserStyle : '',
                                    //...window.universalTagData //not work with all universalTagData (not push event but modify existing event)
                                };
                                if (window.universalTagData.User_Country !== undefined && window.universalTagData.User_Country !== 'N.A.' && window.universalTagData.User_Country !== 'UNDEFINED') {
                                    obj.User_Country = window.universalTagData.User_Country;
                                }
                                window?.tealium_data2track?.push(obj);
                                dispatch(actions.setIsMenuMobileSelected(true));
                            }}
                            className={({ isActive }) => (isActive ? 'active' : undefined)}
                            to={config.pagesUrl.myProfile.myStores}
                        >
                            <ButtonMenu label={getLabelFallback('FAVORITES_MY_STORES_MENU_LABEL')}>
                                <MyStores />
                            </ButtonMenu>
                        </NavLink>
                    </li>
                </ul>
                <div className="menu-section-bottombar"></div>
            </div>
        </nav>
    );
};

export default Menu;
